import { render, staticRenderFns } from "./AI-description.vue?vue&type=template&id=a23f59ce&scoped=true&"
import script from "./AI-description.ts?vue&type=script&lang=js&"
export * from "./AI-description.ts?vue&type=script&lang=js&"
import style0 from "./AI-description.less?vue&type=style&index=0&id=a23f59ce&lang=less&scoped=true&"
import style1 from "./AI-description.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23f59ce",
  null
  
)

export default component.exports